module.exports = __webpack_public_path__ + "img/register.6417c14a.svg";